import {
  IOrder,
  IOrderDetailsDTO,
  PayInvoiceWithPaymentMethodDTO
} from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';
import { Stripe } from 'stripe';

/* -------------------------------------------------------------------------- */
/*                              Order Pay modal                               */
/* -------------------------------------------------------------------------- */
export const openOrderPayModal = createAction(
  '[Orders] Open Pay Order Modal',
  props<{ order: IOrderDetailsDTO }>()
);
export const closeOrderPayModal = createAction(
  '[Orders] Close Pay Order Modal'
);

/* -------------------------------------------------------------------------- */
/*                       Pay invoice with payment method                      */
/* -------------------------------------------------------------------------- */
export const payInvoiceWithPaymentMethod = createAction(
  '[Orders] Pay Invoice With Payment Method',
  props<PayInvoiceWithPaymentMethodDTO>()
);
export const payInvoiceWithPaymentMethodSuccess = createAction(
  '[Orders] Pay Invoice With Payment Method Success',
  props<Stripe.Invoice>()
);
export const payInvoiceWithPaymentMethodFailure = createAction(
  '[Orders] Pay Invoice With Payment Method Failure',
  props<{ error: Error }>()
);

/* -------------------------------------------------------------------------- */
/*                                Order details                               */
/* -------------------------------------------------------------------------- */
export const openOrderDetails = createAction(
  '[Orders] Open Order Details',
  props<{ orderId: number }>()
);
export const openOrderDetailsSuccess = createAction(
  '[Orders]Open Order Details Success',
  props<{ orderDetails: IOrder }>()
);
export const openOrderDetailsFailure = createAction(
  '[Orders] Open Order Details Failure',
  props<{ error: Error }>()
);

/* -------------------------------------------------------------------------- */
/*                                Orders Modal                                */
/* -------------------------------------------------------------------------- */
export const openOrdersModal = createAction('[Orders] Open Orders Modal');
export const openOrdersModalSuccess = createAction(
  '[Orders] Open Orders Modal Success',
  props<{ modalData: any }>()
);
export const openOrdersModalFailure = createAction(
  '[Orders] Open Orders Modal Failure',
  props<{ error: Error }>()
);
export const closeOrdersModal = createAction('[Orders] Close Orders Modal');

/* -------------------------------------------------------------------------- */
/*                                Order History                               */
/* -------------------------------------------------------------------------- */
export const getOrders = createAction(
  '[Orders] Get Order',
  props<{ v?: 1 | 2 }>()
);
export const getOrdersSuccess = createAction(
  '[Orders] Get Order Success',
  props<{ orderHistory: any }>()
);
export const getOrdersFailure = createAction(
  '[Orders] Get Order Failure',
  props<{ error: Error }>()
);
